// Helpers that are better handled by ES5 JS functionality

// TODO: Replace with Array.prototype.includes()
export function isItemIncluded(grouping, id) {
	if (grouping === undefined) return false;
	return grouping.indexOf(id.toString()) !== -1;
}
